import { updateCheckoutButton } from '../utils/buildCheckoutPermalink';

export function initPreactivationUpgradeInput() {
  const boxKeyInput = document.querySelector('input.box-key-input');
  if (boxKeyInput) {
    const boxKeyInputHandler = () => {
      const submittedBoxKey = boxKeyInput.value.trim();
      const boxKeys =
        submittedBoxKey.length >= 7 ? [`EM-${submittedBoxKey}`] : [];
      updateCheckoutButton(boxKeys);
    };

    boxKeyInput.addEventListener('input', boxKeyInputHandler);
  }
}
